module.exports = __webpack_public_path__ + "static/img/salfout.4058d05.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/salfout.png
// module id = OIKr
// module chunks = 1